// A region's own page: its guide, today's quest, and the games that live there.

import { h, clear } from '@kit/dom';
import { artImg } from '@kit/assets';
import { GAMES, lockInfo } from '../registry';
import { REGION_BY_ID, regionOpen, regionQuestsForToday } from '../regions';
import { getSave, subscribe, totalStars } from '../state';
import { topBar, categoryColor } from '../ui';
import { go } from '../router';

export function regionScreen(root: HTMLElement, params: string[]) {
  const r = REGION_BY_ID[params[0]];
  if (!r) { go('map'); return; }
  const bar = topBar(r.name, { back: 'map' });
  const body = h('div.stack', { style: { padding: '0 16px 24px' } });
  root.append(bar, body);

  function render() {
    clear(body);
    const s = getSave();
    if (!regionOpen(r, s)) {
      body.append(h('div.card.center', null, h('h3', null, `${r.name} is still foggy`), h('p.muted', null, `It opens at ${r.stars} stars. You have ${totalStars(s)}.`)));
      return;
    }
    const quest = regionQuestsForToday(s).find(q => q.key.startsWith(`region.${r.id}:`));
    body.append(h('div.card', { style: { borderLeft: `8px solid ${r.color}` } },
      h('p.muted.small', null, `${r.guide.name}, ${r.guide.role}`),
      quest
        ? [
          h('h3', null, 'Today\'s quest'),
          h('p', { style: { margin: '6px 0 10px' } }, quest.job.story),
          quest.done
            ? h('p', { style: { fontWeight: '800', color: 'var(--good)' } }, 'Done for today. A new quest arrives tomorrow.')
            : h('button.btn.primary.block', { onclick: () => go(`play/${quest.job.gameId}/job/${encodeURIComponent(quest.key)}`) }, `Start the quest  +${quest.job.bonus} `, h('span.dot.gem', { style: { display: 'inline-block' } })),
        ]
        : h('p.muted', null, `${r.guide.name} is waiting for you to unlock a game from here.`),
    ));
    body.append(h('h3', { style: { marginTop: '6px' } }, 'Games in this region'));
    for (const g of GAMES.filter(g => r.filter(g))) {
      const lock = lockInfo(g, s);
      body.append(h('div.card.tap' + (lock.unlocked ? '' : '.locked'), {
        style: { borderLeft: `8px solid ${categoryColor(g.category)}` },
        onclick: () => { if (lock.unlocked) go(`play/${g.id}`); },
      }, h('div.row', null, artImg(`icon.${g.id}`, 48), h('div', { style: { flex: '1' } }, h('h3', null, g.title), h('p.muted.small', null, lock.unlocked ? g.blurb : `Opens at ${lock.needStars ? `${lock.needStars} more stars` : 'a few more stars'}.`)))));
    }
  }
  render();
  const un = subscribe(render);
  return () => un();
}
